import { getCurrentInstance } from 'vue';

export const useCtxStore = () => getCurrentInstance().proxy.$root.$store;
